require('./notification/index');
require('./notification/notification');

require('./address/index');
require('./address/city_select');
require('./fullcalendar');
require('./schedule');
import { Chart, registerables } from 'chart.js';
Chart.register(...registerables);
require('./charts');
require('./multitem');
require('./categoryapi');
require('./systemapi');
require('./subsystemapi');
require('./../jquery_extensions');
require('./serviceprovider/index');
require('./preventivemaintenanceapi');

// $('.flipswitch').each(function(){
//     $(this).click(function(){
//         $(this).toggleClass("bg-success");
//     });
//
// });

setInterval(function () {
    $(".alert-item-menu").toggleClass("alert-text-red");
    $(".img-alert").toggleClass("alert-text-red");
}, 1000);

$(".chart_condominios_previstcheck").each(function (item) {
    const realize = parseInt($(this).attr("realize")) || 0;
    const previst = parseInt($(this).attr("previst")) || 0;

    const done = realize;
    const pending = Math.max(0, previst - realize);

    let values, labels, bgColors, hoverBgColors;
    if (done === 0 && pending === 0) {
        values = [1];
        labels = ['Sem Manutenções'];
        bgColors = ['#e2e8f0'];
        hoverBgColors = ['#cbd5e1'];
    } else {
        values = [done, pending];
        labels = ['Realizado', 'Pendente'];
        bgColors = ['#10b981', '#cbd5e1'];
        hoverBgColors = ['#059669', '#94a3b8'];
    }

    const myChart = new Chart($(this), {
        type: 'doughnut',
        data: {
            labels: labels,
            datasets: [{
                data: values,
                backgroundColor: bgColors,
                hoverBackgroundColor: hoverBgColors,
                borderWidth: 0,
                weight: 1
            }]
        },
        options: {
            responsive: true,
            maintainAspectRatio: false,
            cutout: '75%',
            plugins: {
                legend: {
                    display: false
                },
                tooltip: {
                    enabled: true,
                    backgroundColor: 'rgba(15, 23, 42, 0.9)',
                    padding: 8,
                    cornerRadius: 6,
                    titleFont: {
                        size: 11,
                        weight: '600'
                    },
                    bodyFont: {
                        size: 11
                    },
                    displayColors: false
                }
            }
        }
    });
});

$("#preventive_maintenance_id").change(function () {
    if ($(this).val() > 0) {
        $(".btn-add-preventivem").prop("disabled", false);
    } else {
        $(".btn-add-preventivem").prop("disabled", true);

    }
});
$(".btn-select-all").click(function () {
    $(".item-check").each(function () {
        $(this).prop("checked", "checked");
    });
});

$(".multselect").select2();

$(".multselect").on('change', function (e) {
    $("form").submit();
});

$(".multselect_image").select2({
    templateResult: formatState,
    templateSelection: formatState,
    selectOnClose: false
});


function formatState(opt) {
    if (!opt.id) {
        return opt.text;
    }
    let optimage = URL("/images/default_image.png");
    if (!optimage) {
        // This is safe, since you're returning a string
        return opt.text;
    } else {
        // Create an individual image element to properly escape the src url

        if (opt.text.split("#")[1].length > 0)
            optimage = opt.text.split("#")[1];

        // And remember to escape the text we're outputing
        const $opt = $(
            '<span><img src="' + optimage + '" style="width:25px;height: 25px;;object-fit: cover;border-radius: 5px;margin: 3px;" /> ' + opt.text.split("#")[0] + '</span>'
        );

        return $opt;
    }
};

function URL(urlpath) {
    let url = "";
    url += window.location.protocol + "//";
    url += window.location.hostname;
    const porta = window.location.href
        .replace(window.location.protocol + "//", '')
        .replace(window.location.pathname, '')
        .replace(window.location.hostname, '')
        .replace(":", "");

    if (!isNaN(porta) && porta != "") {
        url += ":" + porta;
    }
    if (urlpath.charAt(0) == '/') {
        return url + urlpath;
    } else {
        return url + "/" + urlpath;
    }
}
